export default __webpack_public_path__ + "static/media/jumbotron_karier.795f1076.png";